import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import colors from "/styles/colors";
import PictureComponent from "/components/core/picture/picture-component";
import classnames from "classnames";
import { componentStyles } from "./quote-component.scss";
class QuoteComponent extends PureComponent {
    render() {
        const { activeQuote, aboveTheFold } = this.props;
        const { personImage, personTitle, quoteText, title, color } = activeQuote;
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${componentStyles.__hash}` + " " + "quote-component",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + (classnames("quote-component-inner", {
                        "above-the-fold": aboveTheFold
                    }) || ""),
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: `jsx-${componentStyles.__hash}` + " " + "person-image-section",
                            children: /*#__PURE__*/ _jsx(PictureComponent, {
                                className: "person-image",
                                src: personImage,
                                extraCloudinaryTransformations: {
                                    height: 100,
                                    width: 100
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: `jsx-${componentStyles.__hash}` + " " + "person-text-setcion",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    style: {
                                        color: colors[color]
                                    },
                                    className: `jsx-${componentStyles.__hash}` + " " + "title",
                                    children: title
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: `jsx-${componentStyles.__hash}` + " " + "person-quote",
                                    children: quoteText
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: `jsx-${componentStyles.__hash}` + " " + "person-title",
                                    children: personTitle
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
}
export { QuoteComponent as default };
